import React from 'react';
import ContentLoader from 'react-content-loader';

const ArticleLoader = ({width}) => (
    <ContentLoader
    speed={2}
    width={width}
    height={160}
    viewBox="0 0 400 160"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="10" rx="3" ry="3" width="380" height="20" />
    <rect x="0" y="40" rx="3" ry="3" width="150" height="100" />
    <rect x="160" y="40" rx="3" ry="3" width="100%" height="10" />
    <rect x="160" y="60" rx="3" ry="3" width="100%" height="10" />
    <rect x="160" y="80" rx="3" ry="3" width="100%" height="10" />
    <rect x="160" y="100" rx="3" ry="3" width="220" height="10" />
  </ContentLoader>
  );
  
  export default ArticleLoader;
